import GeneratedMailFilterServiceApi from "./generated/GeneratedMailFilterServiceApi"

class MailFilterServiceApi extends GeneratedMailFilterServiceApi {

}

export const mailFilterServiceApi = new MailFilterServiceApi()
